import Token, { TIPOS_TOKEN } from './Token';

export default class TokenOperador extends Token {
  constructor(valor, label) {
    super(TIPOS_TOKEN.OPERADOR, valor, label);
  }

  // eslint-disable-next-line class-methods-use-this
  siguienteValido(token) {
    if (this.valor === ')') {
      return token.tipo === TIPOS_TOKEN.OPERADOR;
    }
    // La apertura siempre es válida: 1 * (eje_1 + 2)
    if (token.valor === '(') {
      return true;
    }
    return token.tipo !== this.tipo;
  }
}
